// /app/frontend/src/lib/seoReferrer.js
// Helper to persist the SEO page a visitor was on when they clicked a CTA,
// so we can attribute the resulting signup to that page.
//
// Use sessionStorage (per-tab, cleared when tab closes) — appropriate for a
// signup flow that completes in the same session as the CTA click.

const KEY = 'ul_seo_referrer_path';

export function stashSeoReferrer(path) {
  try {
    if (!path) return;
    sessionStorage.setItem(KEY, path);
  } catch {
    // Storage may be unavailable (private mode, etc.) — analytics must never break UX
  }
}

export function readSeoReferrer() {
  try {
    return sessionStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

export function clearSeoReferrer() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
